import { Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivate,
  Router,
  RouterStateSnapshot,
} from '@angular/router';
import { CookieService } from 'ngx-cookie-service';

@Injectable({
  providedIn: 'root',
})
export class AuthGuard implements CanActivate {
  static isLoggedIn: any;
  constructor(private router: Router, private cookieService: CookieService) {}
  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): boolean {
    // Se siamo nel callback OAuth (es. URI con ?code=...),
    // evitiamo il redirect a /login prima che si completi il flusso.
    const hasAuthCode = new URLSearchParams(window.location.search).has('code');
    if (hasAuthCode) {
      this.router.navigate(['/oauth2'], { preserveFragment: true });
      return false;
    }

    if (this.isLoggedIn()) {
      return true;
    }
    //prendo i parametri della url correnti
    const queryParams = route.queryParams;
    // navigate to login page as user is not authenticated
    this.router.navigate(['/login'], {
      //passo i parametri della url correnti
      queryParams: queryParams,
      preserveFragment: true,
    });

    return false;
  }

  isLoggedIn(): boolean {
    const hasCookie = !!this.cookieService.get('oauth-access-token');
    const blockAutoLoginAfterLogout =
      sessionStorage.getItem('blockAutoLoginAfterLogout') === 'true';

    return hasCookie && !blockAutoLoginAfterLogout;
  }
}
